export default function setVariantUrl(id: number | string): void {
  const url = new URL(window.location.href);
  url.searchParams.set("variant", id.toString());
  window.history.replaceState({}, "", url.toString());
}
